import './configureGlobals';
import './FeatureFlags';

import './decorators/qDecorator';
import './decorators/stateServiceDecorator';

import '../common/attributes/tbAutoSelect';
import '../common/attributes/tbButtonClick';
import '../common/attributes/tbButtonDown';
import '../common/attributes/tbFocus/FocusCtrl';
import '../common/attributes/tbFocus/tbFocus';
import '../common/attributes/tbWindowMaxWidth';
import '../common/components/checkboxes/tbCheckbox';
import '../common/components/checkboxes/tbCheckboxGroup';
import '../common/components/checkboxes/tbCheckboxLabel';
import '../common/components/checkboxes/tbCheckboxTristate';
import '../common/components/tbDatePicker/tbDatePicker';
import '../common/react/angularDirectives';
import '../common/react/components/dataGrid/AngularToReactDataGridBridge';
import '../common/react/components/InterpolatedString';
import '../common/utilities/GlobalShortcuts';
import '../common/utilities/TableauLog';
import '../common/utilities/UserAgentSupport';

import './actions/UserSettingsActions';

import '../settings/controllers/ServerSettingsFormCtrl';
import '../settings/controllers/SiteSettingsForBridgeFormCtrl';
import '../settings/controllers/SiteSettingsForServerAdminFormCtrl';
import '../settings/controllers/SiteSettingsForSiteAdminFormCtrl';
import '../settings/directives/tbServerSettingsForm';
import '../settings/directives/tbSettingsCoordinator';
import '../settings/directives/tbSiteSettingsForBridgeForm';
import '../settings/directives/tbSiteSettingsForExtensionsForm';
import '../settings/directives/tbSiteSettingsForServerAdminForm';
import '../settings/directives/tbSiteSettingsForSiteAdminForm';

import './controllers/AddActiveDirectoryGroupDialogCtrl';
import './controllers/AddActiveDirectoryServerUsersDialogCtrl';
import './controllers/AddActiveDirectorySiteUsersDialogCtrl';
import './controllers/AddLocalUserDialogCtrl';
import './controllers/AddUsersToGroupDialogCtrl';
import './controllers/AdminVizViewerCtrl';
import './controllers/BackgroundJobsCtrl';
import './controllers/BulkImportUsersDialogCtrl';
import './controllers/ContentItemPopoverCtrl';
import './controllers/ContentSubplaceCtrl';
import './controllers/CreateOrEditScheduleCtrl';
import './controllers/CreatePersonalAccessTokenDialogCtrl';
import './controllers/DataAlertsCtrl';
import './controllers/DatasourcePlaceCtrl';
import './controllers/DateFilterCtrl';
import './controllers/EditTimeZoneCtrl';
import './controllers/ErrorCtrl';
import './controllers/ExtractTasksCtrl';
import './controllers/FilterPanelCtrl';
import './controllers/FlowPlaceCtrl';
import './controllers/GroupDetailsCtrl';
import './controllers/GroupMembershipDialogCtrl';
import './controllers/GroupPlaceCtrl';
import './controllers/GroupsPlaceCtrl';
import './controllers/GroupUsersSubplaceCtrl';
import './controllers/LicensesCtrl';
import './controllers/LoginCtrl';
import './controllers/MetricsCtrl';
import './controllers/PKCEGenerateCodeChallengeCtrl';
import './controllers/PKCEGetAuthorizationCodeCtrl';
import './controllers/PKCELoginCtrl';
import './controllers/ProjectPlaceCtrl';
import './controllers/RevisionHistoryDialogCtrl';
import './controllers/SchedulePlaceCtrl';
import './controllers/SchedulesCtrl';
import './controllers/ScimSettingsCtrl';
import './controllers/ServerStatusCtrl';
import './controllers/ServerUserPlaceCtrl';
import './controllers/ServerUserSettingsSubplaceCtrl';
import './controllers/ServerUsersPlaceCtrl';
import './controllers/SignedOutCtrl';
import './controllers/SigninErrorCtrl';
import './controllers/SiteMembershipDialogCtrl';
import './controllers/SitePlaceCtrl';
import './controllers/SiteRolesPickerCtrl';
import './controllers/SitesPlaceCtrl';
import './controllers/SiteUserPlaceCtrl';
import './controllers/SiteUserSettingsSubplaceCtrl';
import './controllers/SiteUsersPlaceCtrl';
import './controllers/SubscriptionsCtrl';
import './controllers/TasksCtrl';
import './controllers/VizPreviewCtrl';
import './controllers/WorkbookPublishResultCtrl';
import './controllers/ZiplogCtrl';

import './directives/childEventDirectives';
import './directives/keyEventDirectives';
import './directives/pixelStyleDirectives';
import './directives/tbAlertInfo';
import './directives/tbAppBanner';
import './directives/tbAuthenticationProviderSelector';
import './directives/tbBackgroundImage';
import './directives/tbBulkImportResultsSummary';
import './directives/tbBulkImportUsersForm';
import './directives/tbBytesInputConverter';
import './directives/tbChangePassword';
import './directives/tbDataGrid';
import './directives/tbDataGridBody';
import './directives/tbDataGridEditableRow';
import './directives/tbDataGridHeaders';
import './directives/tbDataSourceCertificationEditor';
import './directives/tbDatasourceExtractRefreshScheduler';
import './directives/tbDatasourceExtractRemoteRefreshScheduler';
import './directives/tbDatasourceExtractRemoteRefreshSelfServiceScheduler';
import './directives/tbDataSourceNlpSettingEditor';
import './directives/tbDaysPicker';
import './directives/tbDevicePreview';
import './directives/tbDisabled';
import './directives/tbDisableSelection';
import './directives/tbEditableCapabilityValue';
import './directives/tbEditableTags';
import './directives/tbEditableText';
import './directives/tbEditableTextarea';
import './directives/tbEditDisplayName';
import './directives/tbEditEmail';
import './directives/tbEditLanguageAndLocale';
import './directives/tbEditTimeZone';
import './directives/tbEmailInputValidator';
import './directives/tbEmbeddedPassword';
import './directives/tbFavoriteToggle';
import './directives/tbFileDrop';
import './directives/tbFileInput';
import './directives/tbFilteringListBox';
import './directives/tbFormattingHints';
import './directives/tbHidden';
import './directives/tbIfFeatureFlag';
import './directives/tbIntegerInputValidator';
import './directives/tbLocalizeTranslate';
import './directives/tbLockUnlockDatabasePermissions';
import './directives/tbLockUnlockPermissions';
import './directives/tbLockUnlockProjectPermissions';
import './directives/tbMatchingInputsValidator';
import './directives/tbModeSwitcher';
import './directives/tbMouseCapture';
import './directives/tbMousedownOutside';
import './directives/tbMouseTrack';
import './directives/tbMouseupOutside';
import './directives/tbOmnibox';
import './directives/tbPermissionRuleEditor';
import './directives/tbPermissionsPanel';
import './directives/tbPlaceDescription';
import './directives/tbPopover';
import './directives/tbPopup';
import './directives/tbPopupMenu';
import './directives/tbPopupMenuButton';
import './directives/tbPopupMenuContent';
import './directives/tbPortInputValidator';
import './directives/tbPreventInput';
import './directives/tbProgressBar';
import './directives/tbRadioButton';
import './directives/tbRangeInputValidator';
import './directives/tbResetStartPage';
import './directives/tbSAMLAuthenticationProvider';
import './directives/tbScroll';
import './directives/tbSelect';
import './directives/tbSelected';
import './directives/tbSelectionMenu';
import './directives/tbSigningIn';
import './directives/tbSignInLogo';
import './directives/tbSiteIdInputValidator';
import './directives/tbSiteRolePermissionsTable';
import './directives/tbSiteRolesPicker';
import './directives/tbStackedElement';
import './directives/tbStateHref';
import './directives/tbTab';
import './directives/tbTagsInput';
import './directives/tbTemplateList';
import './directives/tbTextBox';
import './directives/tbTextDropdown';
import './directives/tbTextile';
import './directives/tbTimePicker';
import './directives/tbTooltipArea';
import './directives/tbTranscludeFn';
import './directives/tbTypeahead';
import './directives/tbTypeaheadFormat';
import './directives/tbUpdateSiteLogoForm';
import './directives/tbUploadIframe';
import './directives/tbUserNameInputValidator';
import './directives/tbUserOrGroupSelector';
import './directives/tbVisible';
import './directives/tbViz';
import './directives/tbWindowResize';
import './directives/tbWorkbookExtractRefreshScheduler';
import './directives/tbWorkerProcessStatus';

import './factories/AngularContextFactory';

import './filters/ActiveLiveQueryRemoteAgentsFilter';
import './filters/CredentialTypeFilter';
import './filters/CronExpressionFilter';
import './filters/LastSignInDateFilter';
import './filters/LicenseTierFilter';
import './filters/ListFilter';
import './filters/LocalizedCountFilter';
import './filters/LocalizedDateFilter';
import './filters/LocalizedPercentFilter';
import './filters/LocalizeTranslateFilter';
import './filters/LocLinkifierFilter';
import './filters/PadFilter';
import './filters/RemoteRefreshScheduleTypeNameFilter';
import './filters/ScheduleActionNameFilter';
import './filters/ScheduleFrequencyDescriptionFilter';
import './filters/ScheduleTypeNameFilter';
import './filters/SiteRoleFilter';
import './filters/SizeFilter';

import './helpers/permissions/PermissionsEditabilityLogicFactory';

import './L10n/L10n';
import './L10n/LocalizeToNgTranslateAdapter';

import './models/FlowPlace';
import './models/PermissionRoles';
import './models/Set';
import './models/SitesPlace';
import './models/SiteUserPlace';
import './models/TaskPlace';

import './resources/ActiveDirectoryGroups';
import './resources/Alerts';
import './resources/BackgroundJobs';
import './resources/Content';
import './resources/Dashboards';
import './resources/DataAlerts';
import './resources/DataAlertUsers';
import './resources/Databases';
import './resources/DataConnections';
import './resources/DataConnectionTypes';
import './resources/Dataroles';
import './resources/DatasourceRevisions';
import './resources/Datasources';
import './resources/DestinationProjects';
import './resources/ExplicitPermissions';
import './resources/ExtractTasks';
import './resources/Favorites';
import './resources/FlowOutputStepRuns';
import './resources/FlowRevisions';
import './resources/Flows';
import './resources/Groups';
import './resources/Languages';
import './resources/Locales';
import './resources/Metrics';
import './resources/OAuthCredentials';
import './resources/PrincipalNames';
import './resources/ProjectNames';
import './resources/Projects';
import './resources/Recents';
import './resources/RemoteRefreshAgents';
import './resources/RemoteRefreshSchedules';
import './resources/RunFlowTasks';
import './resources/Schedules';
import './resources/ServerSettings';
import './resources/ServerUsers';
import './resources/SiteNameSansIds';
import './resources/SiteNameWithIds';
import './resources/SiteRoleOptions';
import './resources/SiteRoles';
import './resources/Sites';
import './resources/SiteUsers';
import './resources/Subscriptions';
import './resources/Tables';
import './resources/Tags';
import './resources/TimeZones';
import './resources/UserNames';
import './resources/Users';
import './resources/UserSettings';
import './resources/Views';
import './resources/VizRecommendations';
import './resources/WorkbookRevisions';
import './resources/Workbooks';

import '../app/spaces/SpacesSiteUrls';
import './services/ActionHelpers';
import './services/ActionPanelService';
import './services/ActivateSitesAction';
import './services/ActiveDirectoryGroupAction';
import './services/AddActiveDirectoryUsersAction';
import './services/AddExternalUsersAction';
import './services/AddGroupsOptionsAction';
import './services/AddLocalUserAction';
import './services/AddOAuthCredentialAction';
import './services/AddSelfToAlertsAction';
import './services/AddUsersOptionsAction';
import './services/AddUsersToGroupAction';
import './services/BackdropService';
import './services/BrowserTitleService';
import './services/BulkImportUsersAction';
import './services/ChangeContentOwnerAction';
import './services/ChangeContentTagsAction';
import './services/ChangeDataAlertOwnerAction';
import './services/ChangeDataRoleOwnerAction';
import './services/ChangeDatasourceDescriptionAction';
import './services/ChangeDatasourceOwnerAction';
import './services/ChangeDatasourceRefreshModeAction';
import './services/ChangeDatasourceRemoteAgentAction';
import './services/ChangeDatasourceRemoteAgentReservationAction';
import './services/ChangeDatasourceRemoteQueryAgentAction';
import './services/ChangeDatasourceRemoteRefreshPropertiesAction';
import './services/ChangeDatasourcesTagsAction';
import './services/ChangeExternalContentContactAction';
import './services/ChangeExtractDsToLiveAction';
import './services/ChangeExtractTaskPriorityAction';
import './services/ChangeFlowDescriptionAction';
import './services/ChangeFlowOwnerAction';
import './services/ChangeFlowsTagsAction';
import './services/ChangeProjectDescriptionAction';
import './services/ChangeProjectOwnerAction';
import './services/ChangeRunFlowTasksPriorityAction';
import './services/ChangeScheduleAction';
import './services/ChangeSubscriptionDataConditionAction';
import './services/ChangeSubscriptionsFormatAction';
import './services/ChangeSubscriptionSubjectAction';
import './services/ChangeTagsActionHelper';
import './services/ChangeViewTagsAction';
import './services/ChangeWorkbookDescriptionAction';
import './services/ChangeWorkbookOwnerAction';
import './services/ChangeWorkbooksTagsAction';
import './services/CheckConnectionCredentialsAction';
import './services/ClearSavedRevisionsAction';
import './services/ConfirmActionDialog';
import './services/ConnectionAuthService';
import './services/ContentActionNotification';
import './services/ContentActions';
import './services/ContentFilterService';
import './services/ContentUrl';
import './services/CreateExtractTasksAction';
import './services/CreateGroupDialogAction';
import './services/CreateProjectAction';
import './services/CreateRemoteRefreshScheduleAction';
import './services/CreateScheduleAction';
import './services/CreateSiteAction';
import './services/DataCatalogApiRequestsService';
import './services/DataQualityService';
import './services/DataRoleErrors';
import './services/DataSourceErrors';
import './services/DeleteConnectedDeviceAction';
import './services/DeleteContentsAction';
import './services/DeleteDataAlertsAction';
import './services/DeleteDatasourcesAction';
import './services/DeleteExtractTasksAction';
import './services/DeleteFlowAction';
import './services/DeleteGroupAction';
import './services/DeleteMyCredentialsAction';
import './services/DeleteOAuthCredentialsAction';
import './services/DeletePersonalAccessTokenAction';
import './services/DeleteProjectsAction';
import './services/DeleteRemoteAgentAction';
import './services/DeleteRemoteRefreshSchedulesAction';
import './services/DeleteRevisionAction';
import './services/DeleteRunFlowTasksAction';
import './services/DeleteSchedulesAction';
import './services/DeleteSitesAction';
import './services/DeleteSubscriptionsAction';
import './services/DeleteUsersFromServerAction';
import './services/DeleteWorkbooksAction';
import './services/DeprecatedAnalyticsService'; // Eventually will be replaced by TelemetryService.
import './services/DesktopApplicationLaunchService';
import './services/DevicePreviewService';
import './services/DownloadActions';
import './services/EditConnectionAction';
import './services/EditGroupMembershipAction';
import './services/EditPermissionsAction';
import './services/EditRemoteRefreshExpectedDurationAction';
import './services/EditRemoteRefreshScheduleAction';
import './services/EditSiteAction';
import './services/EditSiteMembershipAction';
import './services/EffectivePermissionsService';
import './services/ErrorMessageHandler';
import './services/ErrorNotifyingServer';
import './services/ErrorState';
import './services/ExternalAuthService';
import './services/ExtractEncryptionService';
import './services/FavoriteService';
import './services/FetcherFactory';
import './services/FilterPanelService';
import './services/FlowActions';
import './services/FlowErrors';
import './services/FlowsActionNotification';
import './services/ForcePasswordUpdateAction';
import './services/GetActionableObjectsForAction';
import './services/GettingStartedNotifications';
import './services/GranteePermissionsFactory';
import './services/GroupActions';
import './services/GroupsActionNotification';
import './services/HelpService';
import './services/HideViewsAction';
import './services/LicensesService';
import './services/LocalAuthenticationConfigurationService';
import './services/LogoService';
import './services/LongRunningActionService';
import './services/ManageDataAlertRecipientsDialog';
import './services/MastheadNotifications';
import './services/MissingTranslationService';
import './services/MobileAppService';
import './services/ModalService';
import './services/MoveContentAction';
import './services/MoveToProjectAction';
import './services/MultipleSiteRoleMembershipActionNotification';
import './services/NotifyingFutureActionService';
import './services/OAuthCredentialsService';
import './services/PasswordPolicyService';
import './services/PermissionsPanelActions';
import './services/PersonalAccessTokensService';
import './services/PKCEService';
import './services/PollService';
import './services/PostLoginNotifications';
import './services/PreviewWorkbookRevisionAction';
import './services/ProfilePictureService';
import './services/ProjectErrors';
import './services/PublishDatasourceAction';
import './services/PublishFlowAction';
import './services/PublishWorkbookAction';
import './services/QueryService';
import './services/RebuildSearchIndexService';
import './services/RemoveSelfFromAlertsAction';
import './services/RemoveUsersFromGroupAction';
import './services/RemoveUsersFromSiteAction';
import './services/RenameAction';
import './services/ResetLoginRateLimitingAction';
import './services/ResumeDataAlertsAction';
import './services/ResumeRunFlowTasksAction';
import './services/ResumeSubscriptionAction';
import './services/RevisionActions';
import './services/RevisionHistoryAction';
import './services/RunExtractTasksAction';
import './services/RunFlowAction';
import './services/RunFlowOnOutputStepsAction';
import './services/RunFlowOnOutputStepsNotification';
import './services/RunFlowTasksAction';
import './services/RunSchedulesAction';
import './services/RunServerSchedulesAction';
import './services/ScheduleErrors';
import './services/SchedulePermissions';
import './services/SchedulesConfig';
import './services/ScriptLoadingService';
import './services/SearchSuggestionsService';
import './services/ServerInfoService';
import './services/ServerService';
import './services/ServerUsersActions';
import './services/SessionService';
import './services/SetDatabaseControlledPermissionsAction';
import './services/SetDisplayTabsAction';
import './services/SetProjectControlledPermissionsAction';
import './services/SetScheduleStatusAction';
import './services/SetSiteUsersSiteRoleAction';
import './services/SiteAuthenticationSettingsService';
import './services/SiteRolesPickerClientService';
import './services/SiteSwitchService';
import './services/SiteUrlMatcherFactory';
import './services/SiteUsersActions';
import './services/SliceableFactory';
import './services/SorterFactory';
import './services/StackedElementsService';
import './services/StartPageService';
import './services/StateWrapperService';
import './services/SuspendSitesAction';
import './services/TelemetryService';
import './services/TemplatePreloadService';
import './services/ToasterService';
import './services/TopBarService';
import './services/UpdateGroupNameAction';
import './services/UpdateGroupsMinimumSiteRoleAction';
import './services/UpdateUserAuthenticationAction';
import './services/UrlTelemetryService';
import './services/UserActionNotification';
import './services/UserActionResultCode';
import './services/UserLockoutMessageService';
import './services/UserSettingsCtrlCommon';
import './services/UserSettingsNotification';
import './services/ViewErrors';
import './services/VizService';
import './services/WindowLocationService';
import './services/WindowPopupService';
import './services/WorkbookErrors';
import './services/ZiplogService';

import 'focus-visible/dist/focus-visible.min.js';
import 'url-search-params-polyfill';

import './config';
import './contentConfig';
import './ImagePreloader';

import './run';
